/* eslint-disable max-classes-per-file */
class C {}

export function checkProp<T extends C>(obj: T, name: string) {
  if ((obj as any)[name] === undefined) {
    throw new Error(
      `No ${String(name)} passed to ${obj.constructor.name} constructor`
    );
  }
  return true;
}
